<div #widgetRectangle class="wg-widget-content" [ngClass]="{'wg-widget-resizing' : resizing}">
  <div class="wg-resize wg-border-n"></div>
  <div appWidgetDeviceResizer
       class="wg-resize wg-resize-e"
       [widgetRect]="widgetRectangle"
       [widgetCmp]="widgetCmp"
       [widthInSlots]="widthInSlots"
       [minSizeInSlots]="minSizeInSlots"
       [maxSizeInSlots]="maxSizeInSlots"
       [device]="device"
       (resizing)="resizingInProcess($event)"
       (newSize)="getNewSize($event)"
       (movingResizedInProcess)="movingResizer($event)"></div>
  <div class="wg-resize wg-border-s"></div>
  <div class="wg-resize wg-border-w"></div>
</div>
